var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_33209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D8EAF9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 28C26.8333 28 27.5417 27.7083 28.125 27.125C28.7083 26.5417 29 25.8333 29 25C29 24.1667 28.7083 23.4583 28.125 22.875C27.5417 22.2917 26.8333 22 26 22C25.1667 22 24.4583 22.2917 23.875 22.875C23.2917 23.4583 23 24.1667 23 25C23 25.8333 23.2917 26.5417 23.875 27.125C24.4583 27.7083 25.1667 28 26 28V28M26 30C24.6167 30 23.4375 29.5125 22.4625 28.5375C21.4875 27.5625 21 26.3833 21 25C21 23.6167 21.4875 22.4375 22.4625 21.4625C23.4375 20.4875 24.6167 20 26 20C27.3833 20 28.5625 20.4875 29.5375 21.4625C30.5125 22.4375 31 23.6167 31 25C31 26.3833 30.5125 27.5625 29.5375 28.5375C28.5625 29.5125 27.3833 30 26 30V30M19 26H15V24H19V26V26M37 26H33V24H37V26V26M25 18V14H27V18H25V18M25 36V32H27V36H25V36M20.4 20.75L17.875 18.325L19.3 16.85L21.7 19.35L20.4 20.75V20.75M32.7 33.15L30.275 30.625L31.6 29.25L34.125 31.675L32.7 33.15V33.15M30.25 19.4L32.675 16.875L34.15 18.3L31.65 20.7L30.25 19.4V19.4M17.85 31.7L20.375 29.275L21.75 30.6L19.325 33.125L17.85 31.7V31.7M26 25V25V25V25V25V25V25V25V25V25",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_33209",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_33209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_33209",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUv);
export default __webpack_public_path__ + "static/media/uv.afddf34ad9859bd25fa476b49684c861.svg";
export { ForwardRef as ReactComponent };